import { boardsApi } from '../../../api';
import type { Board } from '../../../types';
import type { BoardStateSetter } from '../types';
import { updateBoardInState } from '../utils';

export const createUnpublishBoard = (set: BoardStateSetter) => {
  return async (id: string): Promise<Board> => {
    const updated = await boardsApi.unpublish(id);
    set((state) => updateBoardInState(state, id, updated));
    return updated;
  };
};
